import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { getCanonicalRedirectUrl } from "./lib/canonicalHost";
import { registerNewTrendToastTestHook } from "./lib/newTrendToast";
import { installErrorLogging } from "./lib/errorLogging";
import { AppErrorBoundary } from "./components/AppErrorBoundary";

// Production canonical-host redirect guard
(function enforceCanonicalHost() {
  const target = getCanonicalRedirectUrl(window.location);
  if (target) window.location.replace(target);
})();

registerNewTrendToastTestHook();
installErrorLogging();

createRoot(document.getElementById("root")!).render(
  <AppErrorBoundary>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </AppErrorBoundary>
);
